import React from 'react';

type Props = React.SVGAttributes<SVGElement>;

const ArrowLeftIcon = React.forwardRef<SVGSVGElement, Props>((props, ref) => (
  <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      d="M0.5 9.99977L0.5 10.0002C0.499939 10.134 0.552157 10.2625 0.64547 10.3584L9.64164 19.3545C9.73746 19.4478 9.86596 19.5001 9.99977 19.5H10C10.1326 19.5 10.2598 19.4473 10.3536 19.3536C10.4473 19.2598 10.5 19.1326 10.5 19V18.9998C10.5001 18.866 10.4479 18.7375 10.3546 18.6417L3.05669 11.3538L2.20172 10.5H3.41L21 10.5C21.1326 10.5 21.2598 10.4473 21.3536 10.3536C21.4473 10.2598 21.5 10.1326 21.5 10C21.5 9.86739 21.4473 9.74021 21.3536 9.64645C21.2598 9.55268 21.1326 9.5 21 9.5L3.41 9.5H2.20172L3.05669 8.6462L10.3531 1.35978C10.3536 1.35929 10.3541 1.3588 10.3546 1.3583C10.4479 1.26249 10.5001 1.13401 10.5 1.00023V1C10.5 0.867392 10.4473 0.740213 10.3536 0.646446C10.2598 0.552679 10.1326 0.5 10 0.5H9.99977C9.86598 0.499939 9.73748 0.552149 9.64166 0.645449C9.64118 0.645918 9.6407 0.646389 9.64022 0.64686L0.64686 9.64021C0.646397 9.64069 0.645934 9.64116 0.645472 9.64163C0.552158 9.73746 0.499939 9.86596 0.5 9.99977Z"
      fill="#1A1A1A"
      stroke="currentColor"
    />
  </svg>
));

ArrowLeftIcon.displayName = 'ArrowLeftIcon';

export default ArrowLeftIcon;
